/**
 * Human date formatting for shouts and notifications.
 *
 * Recent timestamps read as relative ("3h ago", "2 days ago"); anything older
 * than about a month falls back to an explicit en-GB date so we never show the
 * US `9/8/2026` ordering that `toLocaleDateString()` picks by default.
 */
export const formatRelativeDate = (input: string | number | Date): string => {
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return '';

  const diffMs = Date.now() - date.getTime();

  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(diffMs / 3_600_000);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(diffMs / 86_400_000);
  if (days < 7) return days === 1 ? '1 day ago' : `${days} days ago`;

  const weeks = Math.floor(days / 7);
  if (weeks < 5) return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;

  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};
